module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAPNJREFUKBWFkL8OwWAUxX3tl24SMVisIjGY6csYqpvNyOIhjP2TxhOYRGIwNBGbySSeQLD2v3OrmqZfcYcmved3zj0tq/0Yx3Havu+vZVmeaJp2JFT6xmfwHnoUhuHWsqwBsZWGD8wYc3VdV8GtyGQYRpOTqzhFeIyxbXsIfSRJ0hzmO/sHI3mTwUtic0NVchkmQ17J8zxKcqmGaZpqkiT0PkONNJlgmvQCejaCIHhwzltxHHcJxgcLMBnSCzjdB5BEUbQD3EPytJxMME1qUBTligsLwGfAJ8CXtyw+Gf5tB+u6KIkbBD45Oh8gKaIsblD79gIc0o+KWl1T4QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/edit.png
// module id = CnJD
// module chunks = 1